import type { Routes } from '@angular/router'
import { AuthGuard } from './auth/auth-guard.service'

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./framework/framework.routes'),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.routes')
  }
]
